// extracted by mini-css-extract-plugin
module.exports = {"container":"Icon_container__V8NyO"};